<div class="jumbotron">
    <h1 class="lead ">SQUARE DOTS </h1>
    <p class="lead mt-3">Pixel art from <br> Lorenzo Roncarati</p>
    <a href="https://www.instagram.com/squared_dots/" target="_blank" style="color:rgb(0, 0, 0)">@square_dots</a>
</div>

<div class="container">
    <router-outlet></router-outlet>
</div>


